import { readRuntimeConfig, type RuntimeConfig } from '@vextura/shell';

export interface ConsoleConfig extends RuntimeConfig {
  /** Whether mock auth fixtures (public/dev-user.json) should be used. */
  mockAuth: boolean;
}

/**
 * Centralized typed config reader. Runtime values come from
 * window.__VEX_CONFIG__ (set by docker-entrypoint from container env);
 * build-time mock-mode flag comes from import.meta.env.
 *
 * Throws on misconfiguration so we fail fast at startup instead of producing
 * confusing runtime errors deep inside the app.
 */
export function loadConsoleConfig(): ConsoleConfig {
  const runtime = readRuntimeConfig();

  if (!runtime.gateUrl) throw new Error('VEX_GATE_URL not configured');
  if (!runtime.authUrl) throw new Error('VEX_AUTH_URL not configured');
  if (!runtime.defaultRegion) throw new Error('VEX_DEFAULT_REGION not configured');

  const mockAuthRaw = import.meta.env['VITE_VEX_MOCK_AUTH'];
  const mockAuth = mockAuthRaw === '1' || mockAuthRaw === 'true';

  return { ...runtime, mockAuth };
}

let cached: ConsoleConfig | null = null;
export function getConsoleConfig(): ConsoleConfig {
  if (!cached) cached = loadConsoleConfig();
  return cached;
}
